namespace nscs.character {

    export class Boss extends Phaser.GameObjects.Container {

        private lives:number = 4;

        chainsMak:Phaser.GameObjects.Graphics;
        chains:Phaser.GameObjects.Sprite;
        claw1_mc:Phaser.Physics.Arcade.Sprite;
        claw2_mc:Phaser.Physics.Arcade.Sprite;
        colonel_mc:Phaser.Physics.Arcade.Sprite;
        rotor1_mc:Phaser.Physics.Arcade.Sprite;
        rotor2_mc:Phaser.Physics.Arcade.Sprite;
        bowsermask_mc:Phaser.Physics.Arcade.Sprite;

        constructor(scene:Phaser.Scene) {
            super(scene, 0, 0);
            
            this.chains = nscs.scene.MainScene.instance.add.sprite( 0, -150,'boss-atlas', 'chains'+'0000');
            this.chains.setOrigin(0.5, 0);

            this.chainsMak = new Phaser.GameObjects.Graphics(this.scene);
            this.chains.mask = this.chainsMak.createGeometryMask();
            
            this.updateChains();
            
            this.claw1_mc = nscs.scene.MainScene.instance.physics.add.sprite( -13, 109,'boss-atlas', 'claw_mc'+'0000');
            this.claw1_mc.setOrigin(47/71, 20/80);
            this.claw1_mc.setBounce(0);
            this.claw1_mc.setCollideWorldBounds(false);
            this.claw1_mc.setImmovable(true);
            this.claw1_mc.body["setAllowGravity"](false);
            this.claw1_mc.body.setSize(47, 30);
            this.claw1_mc.body.setOffset(13, 15);

            this.claw2_mc = nscs.scene.MainScene.instance.physics.add.sprite( 13, 109,'boss-atlas', 'claw_mc'+'0000');
            this.claw2_mc.setOrigin(47/71, 20/80);
            this.claw2_mc.setBounce(0);
            this.claw2_mc.setCollideWorldBounds(false);
            this.claw2_mc.setImmovable(true);
            this.claw2_mc.body["setAllowGravity"](false);
            this.claw2_mc.body.setSize(47, 30);
            this.claw2_mc.body.setOffset(37, 15);
            this.claw2_mc.scaleX = -1;

            this.colonel_mc = nscs.scene.MainScene.instance.physics.add.sprite( 0, 0,'boss-atlas', 'colonel_mc'+'0000');
            this.colonel_mc.setOrigin(56/109, 18/133);
            this.colonel_mc.setBounce(0);
            this.colonel_mc.setCollideWorldBounds(false);
            this.colonel_mc.setImmovable(true);
            this.colonel_mc.body["setAllowGravity"](false);
            this.colonel_mc.body.setSize(80, 50);
            this.colonel_mc.body.setOffset(14, 60);

            this.rotor1_mc = nscs.scene.MainScene.instance.physics.add.sprite( -62, 49,'boss-atlas', 'rotor_mc'+'0000');
            this.rotor1_mc.setOrigin(16/32, 5/33);
            this.rotor1_mc.setBounce(0);
            this.rotor1_mc.setCollideWorldBounds(false);
            this.rotor1_mc.setImmovable(true);
            this.rotor1_mc.body["setAllowGravity"](false);
            this.rotor1_mc.body.setSize(25, 25);
            this.rotor1_mc.body.setOffset(5, 5);

            this.rotor2_mc = nscs.scene.MainScene.instance.physics.add.sprite( 58, 49,'boss-atlas', 'rotor_mc'+'0000');
            this.rotor2_mc.setOrigin(16/32, 5/33);
            this.rotor2_mc.setBounce(0);
            this.rotor2_mc.setCollideWorldBounds(false);
            this.rotor2_mc.setImmovable(true);
            this.rotor2_mc.body["setAllowGravity"](false);
            this.rotor2_mc.body.setSize(25, 25);
            this.rotor2_mc.body.setOffset(5, 5);
            this.rotor2_mc.setFlipX(true);

            this.bowsermask_mc = nscs.scene.MainScene.instance.physics.add.sprite( 0, -7,'boss-atlas', 'bowsermask_mc'+'0000');
            this.bowsermask_mc.setOrigin(31/100, 6/398);
            this.bowsermask_mc.setBounce(0);
            this.bowsermask_mc.setCollideWorldBounds(false);
            this.bowsermask_mc.setImmovable(true);
            this.bowsermask_mc.body["setAllowGravity"](false);
            this.bowsermask_mc.body.setSize(54, 30);
            this.bowsermask_mc.body.setOffset(0, 15);
            
            this.add(this.chainsMak);
            this.add(this.chains);
            this.add(this.claw1_mc);
            this.add(this.claw2_mc);
            this.add(this.colonel_mc);
            this.add(this.rotor1_mc);
            this.add(this.rotor2_mc);
            this.add(this.bowsermask_mc);

            this.claw1_mc.body.checkCollision.left = this.claw1_mc.body.checkCollision.right = this.claw1_mc.body.checkCollision.up = false;
            this.claw2_mc.body.checkCollision.left = this.claw2_mc.body.checkCollision.right = this.claw2_mc.body.checkCollision.up  = false;
            this.colonel_mc.body.checkCollision.down = this.colonel_mc.body.checkCollision.left = this.colonel_mc.body.checkCollision.right = false;

            this.createAnimations();
            
            this.reset();
        }
        
        private playDefAnimations():void {
            this.colonel_mc.play(nscs.gameplay.Factory.createAnimName('normal', 'colonel_mc'));
            this.rotor1_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'rotor_mc'));
            this.rotor2_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'rotor_mc'));
            this.claw1_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'claw_mc'));
            this.claw2_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'claw_mc'));
        }
        
        public reset:()=>void = () => {
            this.setAction(null);
            this.playDefAnimations();
        };
        
        private createAnimations():void {
            let config = {
                'bowsermask_mc': {
                    'idle':{'start': 0, 'end':39, repeat:-1, frameRate:60},
                    'fall':{'start': 40, 'end':101, repeat:0, frameRate:60}
                },
                'colonel_mc': {
                    'normal':{'start': 0, 'end':39, repeat:-1, frameRate:60},
                    'angry':{'start': 40, 'end':64, repeat:-1, frameRate:60},
                },
                'rotor_mc': {
                    'idle':{'start': 0, 'end':4, repeat:-1, frameRate:60}
                },
                'claw_mc': {
                    'idle':{'start': 0, 'end':29, repeat:-1, frameRate:60},
                    'grab':{'start': 30, 'end':40, repeat:0, frameRate:60},
                    'ungrab':{'start': 41, 'end':59, repeat:0, frameRate:60}
                }
            };
            for (let name in config) {
                let animations = config[name];
                for (let k in animations) {
                    let anim:string = nscs.gameplay.Factory.createAnimName(k, name);
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames('boss-atlas', {
                                start: animations[k]['start'], end: animations[k]['end'], zeroPad: 4,
                                prefix: name, suffix: ''
                            }),
                            repeat: animations[k]['repeat'],
                            frameRate: animations[k]['frameRate']
                        });
                    }
                }                
            }
        }

        private player:nscs.character.Player = null;
        private minX:number;
        private maxX:number;
        private topY:number;
        private bottomY:number;
        private dropX:number;
        private topYCatching:number;
        private onDieCallback;
        private onAttackCallback;
        public setup(player:nscs.character.Player, minX:number, maxX:number, topY:number, bottomY:number, dropX:number,  topYCatching:number, onDieCallback, onAttackCallback):void {
            this.player = player;
            this.minX = minX;
            this.maxX = maxX;
            this.topY = topY;
            this.bottomY = bottomY;
            this.dropX = dropX;
            this.topYCatching = topYCatching;
            this.onDieCallback = onDieCallback;
            this.onAttackCallback = onAttackCallback;
        }

        private currAction:string = null;
        private setAction(action:string):void {
            this.currAction = action;
        }

        public hit():void {
            if (this.lives <= 0) return;

            this.lives--;

            if (this.lives == 0) {
                this.setAction('die');
                this.onDieCallback();
                nscs.sound.SoundManager.getInstance().playSound('coloneldieSND');
            } else {
                this.setAction('hit');
                nscs.sound.SoundManager.getInstance().playSound('colonelhitSND');
            }
        }

        private updateAction():void {
            let dx:number = this.x - this.player.sprite.x;
            if (Math.abs(dx) > this.activationTryCatchDist) {
                this.setAction('follow-player');
                this.colonel_mc.flipX = dx < 0;
            } else {                
                this.setAction('try-catch-player');
            }
        }
        
        private tryCatchSpeedY:number = 1;
        private followSpeedX:number = 1;
        private activationTryCatchDist:number = 40;        
        
        private followXStep():void {
            let speedX:number = 0;
            if (this.x < this.player.sprite.x) {
                speedX = this.followSpeedX;
            } else if (this.x > this.player.sprite.x) {
                speedX = -this.followSpeedX;
            }
            this.x += speedX;
        }

        
        private updateAnimation():void {
            if (this.currAction == 'try-catch-player') {
                this.bowsermask_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'bowsermask_mc'));
                
                let dy:number = Math.abs(this.y - this.player.sprite.y);
                if (dy < 150) {
                    let grabAnim:string = nscs.gameplay.Factory.createAnimName('grab', 'claw_mc');
                    let ungrabAnim:string = nscs.gameplay.Factory.createAnimName('ungrab', 'claw_mc');
                    
                    let fn = (claw_mc)=>{
                        if (claw_mc.anims.currentAnim && claw_mc.anims.currentAnim.key != grabAnim && claw_mc.anims.currentAnim.key != ungrabAnim) {
                            claw_mc.play(grabAnim, true);
                            claw_mc.once('animationcomplete', ()=>{
                                if (this.currAction != 'catch-player') {
                                    claw_mc.play(ungrabAnim);
    
                                    claw_mc.once('animationcomplete', ()=>{
                                        claw_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'claw_mc'));
                                    });
                                }
                            });
                            nscs.sound.SoundManager.getInstance().playSound('colonelpincerSND');
                        }    
                    };
                    fn(this.claw1_mc);
                    fn(this.claw2_mc);
                }
            } else if (this.currAction == 'catch-player') {
                this.bowsermask_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'bowsermask_mc'));

                this.claw1_mc.play(nscs.gameplay.Factory.createAnimName('grab', 'claw_mc'));
                this.claw2_mc.play(nscs.gameplay.Factory.createAnimName('grab', 'claw_mc'));                
            } else if (this.currAction == 'drop-player') {
                this.bowsermask_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'bowsermask_mc'));
                this.claw1_mc.play(nscs.gameplay.Factory.createAnimName('ungrab', 'claw_mc'));
                this.claw2_mc.play(nscs.gameplay.Factory.createAnimName('ungrab', 'claw_mc'));
            } else if (this.currAction == 'follow-player') {
                this.bowsermask_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'bowsermask_mc'));
            } else if (this.currAction == 'hit') {
                this.colonel_mc.play(nscs.gameplay.Factory.createAnimName('angry', 'colonel_mc'));                
                
                if (!this.bowsermask_mc["fallen"]) {
                    this.bowsermask_mc["fallen"] = true;
                    this.bowsermask_mc.play(nscs.gameplay.Factory.createAnimName('fall','bowsermask_mc'));
                    this.bowsermask_mc.once('animationcomplete', ()=>{
                        this.bowsermask_mc.visible = false;
                    });
                } else {
                    
                }
                let d = 1500;
                this.blinkRedTint(d, this.claw1_mc, this.claw2_mc, this.colonel_mc, this.rotor1_mc, this.rotor2_mc, this.bowsermask_mc);
                util.Functions.delayedCall(d, ()=>{
                    this.setAction(null);
                    this.colonel_mc.play(nscs.gameplay.Factory.createAnimName('normal', 'colonel_mc'));
                });
                
            } else if (this.currAction == 'die') {
                this.colonel_mc.play(nscs.gameplay.Factory.createAnimName('normal', 'colonel_mc'));
                this.playDieAnimation();
            }   
        }
        
        private blinkRedTint(duration:number, ...sprites):void {
            let n = 10;
            let d = duration / n;
            for (let i:number = 0; i < n; i++) {
                util.Functions.delayedCall(i * d, ()=>{
                    for (let s of sprites) {
                        s.setTint(i % 2 == 0 ? 0xFF0022 : 0xFFFFFF);
                    }
                });
            }
        }
        
        private playDieAnimation():void {
            this.chains.visible = false;
            this.scene.tweens.add({
                targets: this.claw1_mc,
                x: this.claw1_mc.x - 300,
                y: this.claw1_mc.y - 70,
                angle: -195,
                alpha: 0,
                duration: 1000
            });
            this.scene.tweens.add({
                targets: this.claw2_mc,
                x: this.claw2_mc.x + 250,
                y: this.claw2_mc.y + 85,
                angle: 155,
                alpha: 0,
                duration: 1000
            });
            this.scene.tweens.add({
                targets: this.rotor1_mc,
                y: this.rotor1_mc.y + 500,
                duration: 1500
            });
            this.scene.tweens.add({
                targets: this.rotor2_mc,
                y: this.rotor2_mc.y + 500,
                duration: 1500
            });
            this.scene.tweens.add({
                targets: this.colonel_mc,
                y: this.colonel_mc.y + 500,
                duration: 1000,
                ease: Phaser.Math.Easing.Back.In
            });
            
        }
        
        private playerBossDy:number = 110;
        
        private applyAction():void {
            if (this.currAction == 'try-catch-player') {                
                this.followXStep();
                this.y += this.tryCatchSpeedY;
                // if (this.y > this.player.sprite.y - this.playerBossDy) this.y = this.player.sprite.y - this.playerBossDy;
                if (this.y > this.bottomY) this.y = this.bottomY;
            } else if (this.currAction == 'catch-player') {
                this.player.sprite.body["setAllowGravity"](false);
                let _syncPos = ()=>{
                    this.player.sprite.x = this.x;
                    this.player.sprite.y = this.y + this.claw1_mc.y;
                    this.player.sprite.setVelocity(0, 0);
                };
                this.scene.tweens.add({
                    targets: this,
                    y: this.topYCatching,
                    delay: 350,
                    duration: Math.abs(this.y - this.topYCatching) / this.tryCatchSpeedY * 1000 / 60,
                    ease: Phaser.Math.Easing.Linear,
                    onUpdate: _syncPos,
                    onComplete: ()=>{
                        this.scene.tweens.add({
                            targets: this,
                            x: this.dropX,
                            duration: Math.abs(this.dropX - this.x) / this.followSpeedX * 1000 / 60,
                            ease: Phaser.Math.Easing.Linear,
                            onUpdate: _syncPos,
                            onComplete: ()=>{
                                this.setAction('drop-player');
                                this.updateAnimation();
                            }
                        });
                    }
                });
            } else if (this.currAction == 'drop-player') {
                this.player.onRespawn = this.reset;
                
                this.player.sprite.x = this.x;
                this.player.sprite.body["setAllowGravity"](true);
                this.player.doJump(-0.4);
            } else if (this.currAction == 'follow-player') {
                this.followXStep();

                this.y -= this.tryCatchSpeedY;
                if (this.y < this.topY) this.y = this.topY;
            } else if (this.currAction == 'hit') {
            } else if (this.currAction == 'die') {
            }
        }
        
        private checkCollisions():void {
            let dy = this.player.sprite.y - this.y;
            let dx = Math.abs(this.player.sprite.x - this.x);
            if (this.currAction == 'try-catch-player' && dy < this.playerBossDy + 5 && dy > this.playerBossDy - 5 && dx < 5) {
                this.setAction('catch-player');
                return;
            } 
            
            if (this.scene.physics.world.collide(this.player.sprite, this.rotor1_mc) || this.scene.physics.world.collide(this.player.sprite, this.rotor2_mc)) {
                this.player.onRespawn = this.reset;
                this.onAttackCallback();
                return;
            }
            
            let overlaps:boolean = this.scene.physics.world.overlap(this.player.sprite, this.colonel_mc);
            if (overlaps) {
                if (this.colonel_mc.body.touching.up) {
                    if (this.currAction != 'hit') {
                        this.hit();
                    }
                }
            }
        }
        
        private updateChains():void {
            let offsetY:number = 65;
            this.chains.y = -(this.y - this.topY) - offsetY;

            this.chainsMak.clear();
            this.chainsMak.fillStyle(0, 0).fillRect(-this.chains.width/2, 0, this.chains.width, this.y - this.topY + offsetY);
            
            if (this.parentContainer) {
                let ind:number = this.parentContainer.getIndex(this);
                this.parentContainer.addAt(this.chains, ind - 1);
                this.parentContainer.addAt(this.chainsMak, ind - 1);
            }
            this.chains.setPosition(this.x, this.y - offsetY - (this.y - this.topY));
            this.chainsMak.setPosition(this.chains.x, this.chains.y);
        }
        
        private ticker:number = 0;
        public updateBoss():void {
            this.updateChains();
            
            if (this.currAction == 'catch-player') {
                return;
            }

            if (this.currAction != 'drop-player' && this.currAction != 'hit' && this.currAction != 'die') {
                this.updateAction();
                this.checkCollisions();
                this.updateAnimation();
            }
            this.applyAction();

            this.ticker++;
        }

        public destroy(fromScene?: boolean): void {
            super.destroy(fromScene);
            
            if (this.chains.parentContainer) this.chains.parentContainer.add(this.chains);
            if (this.chainsMak.parentContainer) this.chainsMak.parentContainer.add(this.chainsMak);
        }
    }
}